
import { Property, Zone } from '../types';

export const ZONES: Zone[] = [
  // Cotonou
  'Agla', 'Fidjrossè', 'Akogbato', 'St Michel', 'Vedoko', 'Gbegamey', 'Cadjèhoun', 'Aïbatin', 'Atrokpocodji', 'Dekoungbé', 'Joncquet',
  // Akpakpa
  'Akpakpa Midombo', 'Akpakpa Sacré Cœur', 'Akpakpa Dedokpo', 'Akpakpa Le Bélier', 'Akpakpa Segbeya',
  // Calavi
  'Calavi Iita', 'Calavi Aïtchedji', 'Calavi Kpota', 'Calavi Parana', 'Calavi Tankpè', 'Calavi Bakhita', 'Calavi Houèto',
  // Autres
  'Godomey', 'Fignonhoun', 'Togoudo', 'Womey', 'Akassato', 'Ouedo', 'Cocotomey', 'Cococodji', 'Hêvié', 'Gbodjè', 'Bazounkpa', 'Tori'
];

export const MOCK_PROPERTIES: Property[] = [
  // --- LOCATIONS (40%) ---
  {
    id: '1',
    title: 'Appartement moderne Fidjrossè',
    transactionType: 'Location',
    propertyType: 'Appartement',
    price: 150000,
    quartier: 'Fidjrossè',
    address: 'Rue pavée, proche plage',
    bedrooms: 3,
    livingRooms: 1,
    bathrooms: 2,
    surface: 90,
    furnished: false,
    description: "Bel appartement lumineux au 2ème étage, proche de la plage. Cuisine équipée, balcon avec vue dégagée. Quartier calme et sécurisé.",
    images: ['https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1484154218962-a1c002085d2f?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Agent immobilier', name: 'Agence Espoir', memberSince: '2021' },
    datePosted: '2024-05-10',
    featured: true
  },
  {
    id: '2',
    title: 'Entrée personnelle Agla',
    transactionType: 'Location',
    propertyType: 'Entrée personnelle',
    price: 80000,
    quartier: 'Agla',
    address: 'Pylones',
    bedrooms: 2,
    livingRooms: 1,
    bathrooms: 1,
    surface: 70,
    furnished: false,
    description: "Maisonnette entrée personnelle, compteur personnel. Zone accessible.",
    images: ['https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Propriétaire', name: 'M. Dossou', memberSince: '2023' },
    datePosted: '2024-05-12'
  },
  {
    id: '3',
    title: 'Boutique Carrefour Iita',
    transactionType: 'Location',
    propertyType: 'Boutique',
    price: 60000,
    quartier: 'Calavi Iita',
    address: 'Carrefour principal',
    bedrooms: 0,
    livingRooms: 0,
    bathrooms: 0,
    surface: 30,
    furnished: false,
    description: "Boutique avec baie vitrée, idéale pour commerce. Fort passage.",
    images: ['https://images.unsplash.com/photo-1519643381401-22c77e60520e?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Agent immobilier', name: 'Immo Bénin', memberSince: '2020' },
    datePosted: '2024-04-25'
  },
  {
    id: '4',
    title: 'Bureaux Open Space Gbegamey',
    transactionType: 'Location',
    propertyType: 'Bureau',
    price: 300000,
    quartier: 'Gbegamey',
    address: 'Place Bulgarie',
    bedrooms: 0,
    livingRooms: 1,
    bathrooms: 2,
    surface: 120,
    furnished: false,
    description: "Plateau de bureaux moderne, climatisé, gardiennage.",
    images: ['https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Agent immobilier', name: 'Pro Bureaux', memberSince: '2022' },
    datePosted: '2024-05-14'
  },
  {
    id: '5',
    title: 'Villa Duplex Cadjèhoun',
    transactionType: 'Location',
    propertyType: 'Appartement',
    price: 450000,
    quartier: 'Cadjèhoun',
    address: 'Haie Vive',
    bedrooms: 4,
    livingRooms: 2,
    bathrooms: 4,
    surface: 200,
    furnished: false,
    description: "Haut standing, groupe électrogène, sécurité 24h/24.",
    images: ['https://images.unsplash.com/photo-1600596542815-6ad4c727dd2d?auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Agent immobilier', name: 'Luxe Immo', memberSince: '2019' },
    datePosted: '2024-05-15'
  },
  {
    id: '6',
    title: 'Parcelle vide clôturée',
    transactionType: 'Location',
    propertyType: 'Parcelle',
    price: 50000,
    quartier: 'Godomey',
    address: 'Godomey Gare',
    bedrooms: 0,
    livingRooms: 0,
    bathrooms: 0,
    surface: 350,
    furnished: false,
    description: "Terrain à louer pour stockage ou petit commerce temporaire.",
    images: ['https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Propriétaire', name: 'M. Kpodar', memberSince: '2024' },
    datePosted: '2024-03-20'
  },

  // --- VENTES (30%) ---
  {
    id: '7',
    title: 'Maison R+2 Calavi Kpota',
    transactionType: 'Vente',
    propertyType: 'Maison',
    price: 45000000,
    quartier: 'Calavi Kpota',
    address: 'Proche du marché',
    bedrooms: 5,
    livingRooms: 2,
    bathrooms: 4,
    surface: 400,
    furnished: false,
    description: "Grande maison familiale, titre foncier disponible. Garage 2 voitures.",
    images: ['https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Agent immobilier', name: 'Immo Bénin', memberSince: '2020' },
    datePosted: '2024-04-20',
    featured: true
  },
  {
    id: '8',
    title: 'Parcelle Akassato',
    transactionType: 'Vente',
    propertyType: 'Parcelle Nu',
    price: 6000000,
    quartier: 'Akassato',
    address: 'Cité Espoir',
    bedrooms: 0,
    livingRooms: 0,
    bathrooms: 0,
    surface: 500,
    furnished: false,
    description: "Parcelle recasée, zone viabilisée en plein essor.",
    images: ['https://images.unsplash.com/photo-1599809275372-b7f5d7eb80a5?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Propriétaire', name: 'Mme. Afia', memberSince: '2023' },
    datePosted: '2024-05-12'
  },
  {
    id: '9',
    title: 'Immeuble de rapport St Michel',
    transactionType: 'Vente',
    propertyType: 'Immeuble',
    price: 250000000,
    quartier: 'St Michel',
    address: 'Centre commercial',
    bedrooms: 10,
    livingRooms: 5,
    bathrooms: 10,
    surface: 600,
    furnished: false,
    description: "Immeuble R+3 comportant boutiques et appartements. Revenus garantis.",
    images: ['https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Agent immobilier', name: 'Invest Immo', memberSince: '2020' },
    datePosted: '2024-04-01'
  },
  {
    id: '10',
    title: 'Parcelle avec construction inachevée',
    transactionType: 'Vente',
    propertyType: 'Parcelle avec Construction',
    price: 18000000,
    quartier: 'Tori',
    address: 'Centre',
    bedrooms: 0,
    livingRooms: 0,
    bathrooms: 0,
    surface: 1000,
    furnished: false,
    description: "Grand domaine avec fondation R+1 déjà réalisée.",
    images: ['https://images.unsplash.com/photo-1592595896551-12b371d546d5?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Propriétaire', name: 'Jean', memberSince: '2022' },
    datePosted: '2024-03-15'
  },

  // --- MEUBLÉS (30%) ---
  {
    id: '11',
    title: 'Studio Chic Fidjrossè',
    transactionType: 'Meublé',
    propertyType: 'Appartement meublé',
    price: 250000,
    quartier: 'Fidjrossè',
    address: 'Zone Ambassade',
    bedrooms: 1,
    livingRooms: 1,
    bathrooms: 1,
    surface: 40,
    furnished: true,
    description: "Studio design, tout inclus (canal, wifi, eau). Idéal court séjour.",
    images: ['https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1556020685-ae41abfc9365?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Agent immobilier', name: 'Stay Benin', memberSince: '2023' },
    datePosted: '2024-05-18',
    featured: true
  },
  {
    id: '12',
    title: 'Appart 2 Chambres Haie Vive',
    transactionType: 'Meublé',
    propertyType: 'Appartement meublé',
    price: 600000,
    quartier: 'Cadjèhoun',
    address: 'Haie Vive',
    bedrooms: 2,
    livingRooms: 1,
    bathrooms: 2,
    surface: 100,
    furnished: true,
    description: "Luxueux appartement au cœur de la ville. Ménage inclus.",
    images: ['https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1484154218962-a1c002085d2f?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Agent immobilier', name: 'Luxe Immo', memberSince: '2019' },
    datePosted: '2024-05-16'
  },
  {
    id: '13',
    title: 'Chambre Salon Meublé Vedoko',
    transactionType: 'Meublé',
    propertyType: 'Appartement meublé',
    price: 150000,
    quartier: 'Vedoko',
    address: 'Carrefour Toyoyta',
    bedrooms: 1,
    livingRooms: 1,
    bathrooms: 1,
    surface: 50,
    furnished: true,
    description: "Appartement confortable et accessible. Wifi disponible.",
    images: ['https://images.unsplash.com/photo-1536376072261-38c75010e6c9?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Propriétaire', name: 'Mme. Sossa', memberSince: '2022' },
    datePosted: '2024-05-05'
  },
  {
    id: '14',
    title: 'Loft Akpakpa',
    transactionType: 'Meublé',
    propertyType: 'Appartement meublé',
    price: 200000,
    quartier: 'Akpakpa Sacré Cœur',
    address: 'Ciné Concorde',
    bedrooms: 1,
    livingRooms: 1,
    bathrooms: 1,
    surface: 60,
    furnished: true,
    description: "Loft moderne avec décoration soignée.",
    images: ['https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Propriétaire', name: 'M. Ali', memberSince: '2023' },
    datePosted: '2024-05-08'
  },
  {
    id: '15',
    title: 'Résidence Hôtes Calavi',
    transactionType: 'Meublé',
    propertyType: 'Appartement meublé',
    price: 120000,
    quartier: 'Calavi Aïtchedji',
    address: 'Pavé principal',
    bedrooms: 2,
    livingRooms: 1,
    bathrooms: 1,
    surface: 75,
    furnished: true,
    description: "Appartement simple et propre pour séjour en famille.",
    images: ['https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=800&q=80'],
    advertiser: { type: 'Agent immobilier', name: 'Calavi Immo', memberSince: '2021' },
    datePosted: '2024-05-14'
  }
];
